export const SET_HIGHEST_STEP_ACTION = {
    name: 'SET_HIGHEST_STEP_ACTION',
    action: step => ({
        step,
        type: SET_HIGHEST_STEP_ACTION.name
    })
};

export const ERROR_GOT_LOCATIONS_ACTION = {
    name: 'ERROR_GOT_LOCATIONS_ACTION',
    action: () => ({
        type: ERROR_GOT_LOCATIONS_ACTION.name
    })
};

export const CLEAN_LOAN_APPLICATION_DATA_ACTION = {
    name: 'CLEAN_LOAN_APPLICATION_DATA_ACTION',
    action: country => ({
        country,
        type: CLEAN_LOAN_APPLICATION_DATA_ACTION.name
    })
};

export const GET_ALL_QUOTATION_INSURANCES_ACTION = {
    name: 'GET_ALL_QUOTATION_INSURANCES_ACTION',
    action: (year, postalCode, cveClick, term, shouldShowLoading = false) => ({
        year, postalCode, cveClick, term, shouldShowLoading,
        type: GET_ALL_QUOTATION_INSURANCES_ACTION.name
    })
};

export const GET_ALL_QUOTATION_INSURANCES_ACTION_CANCELLED = {
    name: 'GET_ALL_QUOTATION_INSURANCES_ACTION_CANCELLED',
    action: () => ({
        type: GET_ALL_QUOTATION_INSURANCES_ACTION_CANCELLED.name
    })
};

export const SET_AS_AN_OLD_LOAN_APPLICATION = {
    name: 'SET_AS_AN_OLD_LOAN_APPLICATION',
    action: () => ({
        type: SET_AS_AN_OLD_LOAN_APPLICATION.name
    })
};